import controller from './controller';

const template = require('./connectionstatus.html');

export default {
    bindings: {
        device: '<',
        onPublishEvent: '&'
    },
    controller,
    template
};
